export const AUTH_STORAGE_KEY = "";
export const MAX_LENGTH_TEXT = 5;
export const PARAM_URL_UTM_ORIGIN = "utm_o";
